export default __webpack_public_path__ + "static/media/ic_tiles.84ed14db.svg";